import {NfMessage, NfMessageType} from "../NfMessage";

/**
 * Wiadomość do wszystkich komponentów w zakładce informująca o id zakładki przeglądarki
 */
export class SetBrowserTabId extends NfMessage {
    public constructor(browserTabId: string|MessageEvent<SetBrowserTabId>) {
        super(NfMessageType.SetBrowserTabId);
        if(NfMessage.isMessageEvent(browserTabId)) {
            Object.assign(this, browserTabId.data);
        } else {
            this.browserTabId = browserTabId;
        }
    }
    public type = NfMessageType.SetBrowserTabId;
    public browserTabId:string = '';
}
NfMessage.creationCallbacks[NfMessageType.SetBrowserTabId] = (event) => {
    return new SetBrowserTabId(event);
}

